'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import BreakdownScore from './BreakdownScore';
import ScoreConstants from '../constants/ScoreConstants';

var BreakdownScoreContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(BreakdownScoreContainer, _React$Component);

  function BreakdownScoreContainer() {
    _classCallCheck(this, BreakdownScoreContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(BreakdownScoreContainer).apply(this, arguments));
  }

  _createClass(BreakdownScoreContainer, [{
    key: "render",
    value: function render() {
      var websiteGrade = this.props.websiteGrade;
      var performanceScore = websiteGrade.get('performanceAudit').get('grade');
      var mobileGrade = websiteGrade.get('mobileAudit').get('grade');
      var seoGrade = websiteGrade.get('seoAudit').get('grade');
      var securityGrade = websiteGrade.get('securityAudit').get('grade');
      return /*#__PURE__*/_jsxs("div", {
        className: "breakdown-score-container",
        children: [/*#__PURE__*/_jsx(BreakdownScore, {
          page: "performance",
          score: performanceScore,
          overallScore: ScoreConstants.PERFORMANCE_OVERALL
        }), /*#__PURE__*/_jsx(BreakdownScore, {
          page: "seo",
          score: seoGrade,
          overallScore: ScoreConstants.SEO_OVERALL
        }), /*#__PURE__*/_jsx(BreakdownScore, {
          page: "mobile",
          score: mobileGrade,
          overallScore: ScoreConstants.MOBILE_OVERALL
        }), /*#__PURE__*/_jsx(BreakdownScore, {
          page: "security",
          score: securityGrade,
          overallScore: ScoreConstants.SECURITY_OVERALL
        })]
      });
    }
  }]);

  return BreakdownScoreContainer;
}(React.Component);

export { BreakdownScoreContainer as default };